import {
  ResponseData,
  TAnalysisRevenueResponse,
  TAnalysisSampleResponse,
  TAnalysisV2SampleResponse,
  TOauthAuthorizationInfo,
  TOauthInfo,
  TSampleInfo,
  TSampleProcessInfo,
  TSampleResponse,
  TShowCaseResponse,
  TUserInfo,
  TUserLevelRulesResponse,
  TUserOverviewResponse,
} from "@/typings";
import { fetchYooFindsApi } from "@/utils/fetch";
import { getUri } from "@/utils/url";
import {
  GetAnalysisRevenueParams,
  GetOauthAuthorizationParams,
  GetOauthParams,
  GetSampleDetailParams,
  GetSampleParams,
  GetSampleProcessParams,
  GetShowCaseParams,
} from "./interface";
import { OauthClient, OauthPlatform } from "@/shared";
import { omit } from "lodash";
import { YOO_FINDS_DOMAIN } from "@/common";

const oauthParams = {
  platform: OauthPlatform.TikTok,
  client: OauthClient.Web,
};

export async function fetchOauth(params: GetOauthParams) {
  const _oauthPathParams = {
    ...oauthParams,
    ...(params.client && { client: params.client }),
    ...(params.platform && { platform: params.platform }),
  };
  return await fetchYooFindsApi<ResponseData<TOauthInfo>>(
    getUri(
      `api/oauth/${_oauthPathParams.platform}/${_oauthPathParams.client}`,
      {
        callback: `${YOO_FINDS_DOMAIN}login`,
        redirect: `${YOO_FINDS_DOMAIN}home`,
        ...omit(params, ["client", "platform"]),
      }
    )
  );
}

export async function fetchOauthAuthorization(
  params: GetOauthAuthorizationParams
) {
  return await fetchYooFindsApi<ResponseData<TOauthAuthorizationInfo>>(
    getUri("api/oauth/authorization", params)
  );
}

export async function fetchUserInfo(params: any) {
  return await fetchYooFindsApi<ResponseData<TUserInfo>>(
    getUri("api/user/info", params)
  );
}

export async function fetchLogout(params: any) {
  return await fetchYooFindsApi<ResponseData<void>>(
    getUri("api/auth/logout", params)
  );
}

export async function fetchShowCase(params: GetShowCaseParams) {
  return await fetchYooFindsApi<ResponseData<TShowCaseResponse>>(
    getUri("api/v2/showcase/list", { page: 1, page_size: 10, ...params })
  );
}

export async function fetchSample(params: GetSampleParams) {
  return await fetchYooFindsApi<ResponseData<TSampleResponse>>(
    getUri("api/samples", { page: 1, page_size: 10, ...params })
  );
}

export async function fetchSampleDetail(params: GetSampleDetailParams) {
  return await fetchYooFindsApi<ResponseData<TSampleInfo>>(
    getUri(`api/samples/${params.sample_order}`, {})
  );
}

export async function fetchSampleProcess(params: GetSampleProcessParams) {
  return await fetchYooFindsApi<ResponseData<TSampleProcessInfo[]>>(
    getUri(`api/samples/${params.sample_order}/process`, {})
  );
}

export async function fetchUserLevelRules() {
  return await fetchYooFindsApi<ResponseData<TUserLevelRulesResponse>>(
    getUri(`api/samples/level/rules`, {})
  );
}

export async function fetchUserOverview() {
  return await fetchYooFindsApi<ResponseData<TUserOverviewResponse>>(
    getUri(`api/v2/user/overview`, {})
  );
}

export async function fetchAnalysisRevenue(params: GetAnalysisRevenueParams) {
  return await fetchYooFindsApi<ResponseData<TAnalysisRevenueResponse>>(
    getUri(`api/v2/user/analysis/revenue`, params)
  );
}

export async function fetchAnalysisSample() {
  return await fetchYooFindsApi<ResponseData<TAnalysisSampleResponse>>(
    getUri(`api/v2/user/analysis/sample`, {})
  );
}

export async function fetchAnalysisV2Sample() {
  return await fetchYooFindsApi<ResponseData<TAnalysisV2SampleResponse[]>>(
    "api/v2/user/analysisV2/sample"
  );
}
